import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const SuppressionDonneesPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#09090b]">
      <header className="sticky top-0 z-50 bg-[#09090b]/95 backdrop-blur-md border-b border-zinc-800">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-zinc-400 hover:text-white transition">
            <ArrowLeft className="w-5 h-5" />
            <img src="/logo-youmi.png" alt="YOUMI GREEN VTC" className="w-10 h-10" />
            <span className="text-lg font-bold text-white font-['Outfit']">YOUMI <span className="text-emerald-500">GREEN</span></span>
          </button>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-white font-['Outfit'] mb-8" data-testid="suppression-donnees-title">{t('deletion_title')}</h1>

        <div className="space-y-8 text-zinc-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">{t('deletion_how')}</h2>
            <p>{t('deletion_rgpd')} <strong className="text-white">YOUMI GREEN VTC</strong>.</p>
            <p className="mt-3">{t('deletion_send_email')}</p>
            <div className="mt-3 bg-zinc-800/50 border border-zinc-700 rounded-lg p-4">
              <p className="text-white font-semibold">
                <a href="mailto:contact@youmigreenvtc.com?subject=Suppression%20des%20donn%C3%A9es" className="text-emerald-400 hover:underline">contact@youmigreenvtc.com</a>
              </p>
              <p className="text-zinc-400 text-sm mt-1">{t('deletion_subject')} <strong className="text-white">{t('deletion_subject_value')}</strong></p>
            </div>
            <p className="mt-3">{t('deletion_info_required')}</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400">
              <li><strong className="text-zinc-200">{t('deletion_info_name')}</strong></li>
              <li><strong className="text-zinc-200">{t('deletion_info_email')}</strong></li>
              <li><strong className="text-zinc-200">{t('deletion_info_phone')}</strong></li>
              <li>{t('deletion_info_other')}</li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">{t('deletion_delay_title')}</h2>
            <p>{t('deletion_delay_text')}</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">{t('deletion_data_title')}</h2>
            <p>{t('deletion_data_text')}</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400">
              <li>{t('deletion_data_1')}</li>
              <li>{t('deletion_data_2')}</li>
              <li>{t('deletion_data_3')}</li>
              <li>{t('deletion_data_4')}</li>
              <li>{t('deletion_data_5')}</li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">{t('deletion_exceptions_title')}</h2>
            <p>{t('deletion_exceptions_text')}</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400">
              <li><strong className="text-zinc-200">{t('deletion_exc_1')}</strong> : {t('deletion_exc_1_detail')}</li>
              <li><strong className="text-zinc-200">{t('deletion_exc_2')}</strong> : {t('deletion_exc_2_detail')}</li>
              <li><strong className="text-zinc-200">{t('deletion_exc_3')}</strong> : {t('deletion_exc_3_detail')}</li>
              <li><strong className="text-zinc-200">{t('deletion_exc_4')}</strong> : {t('deletion_exc_4_detail')}</li>
            </ul>
            <p className="mt-3 text-zinc-500 text-sm">{t('deletion_retained_note')}</p>
          </section>
          <section className="border-t border-zinc-800 pt-6">
            <p className="text-zinc-500 text-sm">
              YOUMI GREEN VTC (SASU), SIREN 889 633 020, 1 rue du Bel Air, 91000 Evry-Courcouronnes.
              <br />Contact DPO : <a href="mailto:contact@youmigreenvtc.com" className="text-emerald-400 hover:underline">contact@youmigreenvtc.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SuppressionDonneesPage;
